// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import Snap from 'snapsvg'
import slick from 'slick-carousel'
import ResizeSensor from './vendor/ResizeSensor.js'
import StickySidebar from 'sticky-sidebar'
import SimpleBar from 'simplebar'
//import stick_in_parent from 'sticky-kit'

require('sticky-kit/dist/sticky-kit.js');
const ScrollMagic = require('ScrollMagic');
//require('debug.addIndicators');

var global = {
    init () {
        this.initEvents();
        this.initPageScroll();
        this.initSlickSlider();
        if ($('.js-fixed-slide-over').length && $(window).width() >= 1024 && $(window).height() >= 670) {
            this.initSlideOverHeader();
        }
    },
    initEvents () {
        var self = this;
        //Window resize event
        $(window).on('resize orientationchange', function () {
            self.initOnWindowResize();
        });
        //Hamburger Menu
        $(document).on('click touchstart tap', '.js-hamburger', function () {
            self.openMobileMenu();
            return false;
        });
        //Mobile Menu panel
        $(document).on('click tap', '.js-close-mobile-nav, .c-mobile-nav-overlay', function (event) {
            if ($('.js-menu-open').length) {
                self.closeMobileMenu();
                return false;
            }
        });
        //open search
        $(document).on('click touchstart tap', '.js-open-search', function () {
            self.openSearch();
            return false;
        });
        //close search
        $(document).on('click touchstart tap', '.js-close-search', function () {
            self.closeSearch();
            return false;
        });
        //Open Mobile Sub Nav
        $(document).on('click touchstart tap', '.js-open-mobile-sub-nav', function () {
            self.openMobileSubNav();
            return false;
        })
        //Close Mobile Sub Nav
        $(document).on('click touchstart tap', '.js-close-mobile-sub-nav', function () {
            self.closeMobileSubNav();
            return false;
        })
        //Scroll to content if hash is set
        var hash = window.location.hash;
        if (hash == '#scroll' && $(".js-wrapper--fixed-spacing").length) {
            this.scrollToContent();
            return false;
        }

    },
    openMobileMenu() {
        $('.js-hamburger').addClass('is-active');
        $('.c-mobile-nav-overlay').addClass('c-mobile-nav-overlay--active');
        setTimeout(function () {
            $('body').addClass('js-menu-open');
        }, 500);
        $('.js-mobile-menu').addClass('c-mobile-nav-panel--open');
    },
    closeMobileMenu() {
        $('.js-hamburger').removeClass('is-active');
        $('body').removeClass('js-menu-open');
        $('.c-mobile-nav-overlay').removeClass('c-mobile-nav-overlay--active');
        $('.js-mobile-menu').removeClass('c-mobile-nav-panel--open');
    },
    initSlickSlider() {   
        var wrapper = $('.js-hero-slider');

        wrapper.on('init', function() {
            var maxHeight = 0;
            $('.js-tab-menu-item').each(function() {
                if ($(this).outerHeight() > maxHeight) {
                    maxHeight = $(this).outerHeight();
                }
            })
            $('.js-tab-menu-item').css('height', maxHeight);
        })

        wrapper.slick({
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            dots: false,
            infinite: false,
            arrows: false,
            mobileFirst: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                }
            ]
        });
    },
    setActiveSlideHero() {
        
        
        var slideNo = $('.c-hero-nav-item--active').data('slide');

        console.log('hero slider '+ slideNo);

        $('.js-hero-slider').slick('slickGoTo', slideNo);
        
                     
    },
    setActiveSliderTwoColumnLink(){
        
        var slideNo = $('.c-sticky-sidebar__menu-item--active').data('slide');

        console.log('slide num '+slideNo);

        $('.js-scroll-mobile-slider').slick('slickGoTo', slideNo);
    },

    openSearch() {
        $('.js-open-search').removeClass('svg-search--active');
        $('.js-close-search').addClass('c-search-field__close--active');
        $('.c-search-field').addClass('c-search-field--active');
    },
    closeSearch() {
        $('.js-open-search').addClass('svg-search--active');
        $('.js-close-search').removeClass('c-search-field__close--active');
        $('.c-search-field').removeClass('c-search-field--active');
    },
    openMobileSubNav() {
        //$('.c-mobile-sub-nav').addClass('c-mobile-sub-nav--open');
        $('.js-primary-nav').addClass('c-mobile-nav--slide-out');
    },
    closeMobileSubNav() {
        //$('.c-mobile-sub-nav').removeClass('c-mobile-sub-nav--open');
        $('.js-primary-nav').removeClass('c-mobile-nav--slide-out');
    },
    initOnWindowResize() {
        var windowWidth = $(window).width(),
            windowHeight = $(window).height();
        
        if (!$('.js-hero-slider').hasClass('slick-initialized')) {
            $('.js-hero-slider').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                dots: false,
                infinite: false,
                arrows: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: 'unslick'
                    }
                ]
            });
        }

        if (windowWidth > 102 && $('.home').length) {
            home.initTabs();
        }

        if (windowWidth >= 1024 && windowHeight >= 670) {
            this.initSlideOverHeader();
        }
        else {
            this.disableSlideOverHeader();
        }
    },
    initSlideOverHeader() {
        var headerHeight = $('.js-fixed-slide-over').height() + 114;

        $('.js-wrapper--fixed-spacing').css('marginTop', headerHeight);
    },
    disableSlideOverHeader() {
        $('.js-wrapper--fixed-spacing').css('marginTop', 'auto');
    },
    scrollToContent() {
        
        var offset = $('.js-fixed-slide-over').height() + 90;

        setTimeout(function () {
            $([document.documentElement, document.body]).animate({
                scrollTop: offset
            }, 1000);
        }, 500)
        
    },
    initPageScroll() {
        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            if ( scrollTop > 0 ) { 
                $('.js-header').addClass('c-header--top');
            }
            else {
                $('.js-header').removeClass('c-header--top');
            }
        });
    }

}

var home = {
    init () {
        var self = this;

        this.initTabs();
        this.initTabMenuSlider();

        //Window resize event
        $(window).on('resize orientationchange', function () {
            if (!$('.js-tabmenu-slider').hasClass('slick-initialized')) {
                console.log('here');
                self.initTabMenuSlider();
            }
        });
    },
    initTabs () {
        /*Activate default tab contents*/
        var leftPos, newWidth, $magicLine;  
                          
        $magicLine = $('.c-home-section-nav__magic-line');		    
        $magicLine.width($('.c-home-section-nav__menu-item--active').width())
            .css('left', $('.c-home-section-nav__menu-item--active a').position().left)
            .data('origLeft', $magicLine.position().left)
            .data('origWidth', $magicLine.width());				
        
        // Magicline hover animation - Desktop only 
        $(document).on({
            mouseenter: function () {
                var $thisBar = $(this),
                colour = $thisBar.data('colour');
            
                console.log('hovwer');

                leftPos = $thisBar.position().left;	
                newWidth = $thisBar.parent().width();

                $magicLine.attr('class', 'c-home-section-nav__magic-line c-home-section-nav__magic-line--' + colour);
                $magicLine.stop().animate({left:leftPos,width:newWidth});
            },
            mouseleave: function () {
                var activeColour = $('.c-home-section-nav__menu-item--active a').data('colour');
            
                $magicLine.stop().animate({left:$magicLine.data('origLeft'),width: $magicLine.data('origWidth')});  
                $magicLine.attr('class', 'c-home-section-nav__magic-line c-home-section-nav__magic-line--' + activeColour);
            }
        }, '.js-tab-menu-link');

        $(document).on('click', '.js-tab-menu-link', function () {
            var target = $(this).data('target'),
                targetEl = $('.' + target), 
                index = $(this).data('index');

            $('.c-home-section-nav__menu-item').removeClass('c-home-section-nav__menu-item--active');
            $(this).parent().addClass('c-home-section-nav__menu-item--active');

            //set clicked item to active slide
            if ($('.slick-slider').slick('slickCurrentSlide') !== index) {
                $('.js-tabmenu-slider').slick('slickGoTo', index);
            }

            $magicLine
                .data('origLeft',$(this).position().left)
                .data('origWidth',$(this).width() + 40);

            //Change the tab
            if (!targetEl.hasClass('c-tab--active')) {
                $('.c-tab--active').removeClass('c-tab--animate-in').addClass('c-tab--animate-out');

                setTimeout(function () {
                    targetEl.addClass('c-tab--active').siblings().removeClass('c-tab--active');
                    $('.c-tab--active').removeClass('c-tab--animate-out').addClass('c-tab--animate-in');
                }, 500);
            }

            return false;
        });
    },
    initTabMenuSlider() {   
        var wrapper = $('.js-tabmenu-slider');

        wrapper.on('init', function() {
            var maxHeight = 0;
            $('.js-tab-menu-item').each(function() {
                if ($(this).outerHeight() > maxHeight) {
                    maxHeight = $(this).outerHeight();
                }
            })
            $('.js-tab-menu-item').css('height', maxHeight);
        })

        wrapper.slick({
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            dots: false,
            infinite: true,
            arrows: false,
            mobileFirst: true,
            variableWidth: true,
            centerMode: true,
            centerPadding: 0,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                }
            ]
        });
    }
}

var content_navigation = {
    init () {
        var windowWidth = $(window).width();
        
        this.initEvents();

        if(windowWidth > 1024) {
            this.initStickySidebar();
            this.slidingLine();

            if ($('.js-sidebar-link').length) {
                this.magicScroll();
            }
        } else {
            this.initMobileTabs();
            this.initSlickSlider();
        } 
    },

    initEvents () {
        var self = this;

        //Window resize event
        $(window).on('resize orientationchange', function () {
            self.initOnScreenResize();

            return false;
        });

        //Sticky Sidebar On Click open tab content
        $(document).on('click', '.js-sidebar-link', function () {
            var event = $(this);
            var identifier = event.data('to');

            if(identifier) {
                self.scrollToContent(event, identifier);
            }

            return false;
        })
    },
    initMobileTabs () {
        //Activate mobile default tab contents*
        var leftPos, newWidth, $magicLine; 
        var that = this;
                    
        $('.c-sticky-sidebar__menu').append("<li class='c-sticky-sidebar__magic-line'></li>");
            $magicLine = $('.c-sticky-sidebar__magic-line');		    
            $magicLine.width($('.c-sticky-sidebar__menu-item--active').width())
                .css('left', $('.c-sticky-sidebar__menu-item--active').position().left)
                .data('origLeft', $magicLine.position().left)
                .data('origWidth', $magicLine.width());				
        

        //Change the tab contents on click
        $(document).on('click', '.js-scroll-menu-link', function () {
            var target = $(this).data('to'),
                targetEl = $('.' + target), 
                leftBox,
                rightBox;
            console.log(target);
            var event = $(this);
            var identifier = event.data('to');

            $('.c-sticky-sidebar__menu-item').removeClass('c-sticky-sidebar__menu-item--active');
            $(this).parent().addClass('c-sticky-sidebar__menu-item--active');

            $magicLine
                .data('origLeft',$(this).position().left)
                .data('origWidth',$(this).width() + 40);

            that.openMobileContent(event, identifier);
            

            return false;
        });

        //Change the tab contents on pagination click
        $(document).on('click', '.js-pagination-link', function () {
            var target = $(this).data('to'),
                targetEl = $('.' + target), 
                leftBox,
                rightBox;
            
            var event = $(this);
            var identifier = event.data('to');
            var links = [];


            $('.c-sticky-sidebar__menu-item').removeClass('c-sticky-sidebar__menu-item--active');
    
            //Grab all the links and put the one we want to set as active in a links array
            $('.c-sticky-sidebar__menu-link').each(function() {
                if($(this).data('to') == identifier) {
                    links.push($(this));
                }
            })

            //Set link with matching data-to as active link
            if(links[0]) {

                links[0].parent().addClass('c-sticky-sidebar__menu-item--active');

                //Position magic line accordingly
                $magicLine
                .data('origLeft',links[0].position().left)
                .data('origWidth',links[0].width() + 40);
              
                //Set active tab
                var actIndex = links[0].parents('.slick-active').attr('data-slick-index');
                $('.js-scroll-mobile-slider').slick('slickGoTo', actIndex);
            }

            that.openMobileContent(event, identifier);
            
            return false;
        });

    },
    initSlickSlider() {   
        var wrapper = $('.js-scroll-mobile-slider');

        wrapper.slick({
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            dots: false,
            infinite: false,
            arrows: false,
            mobileFirst: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                }
            ]
        });
    },
    initStickySidebar() {
        $('#js-sidebar').stick_in_parent({
            offset_top: 204
        });
    },
    initOnScreenResize() {
        var windowWidth = $(window).width();
        
        if (!$('.js-scroll-mobile-slider').hasClass('slick-initialized')) {
            $('.js-scroll-mobile-slider').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                dots: false,
                infinite: false,
                arrows: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: 'unslick'
                    }
                ]
            });
        }
    },
    magicScroll() {
        // init controller
        var controller = new ScrollMagic.Controller(),
            section = []
            self = this;

        //Grab all the tab contents and put them in sections array
        $('.c-sticky-sidebar__tabcontent').each(function() {
            section.push($(this));
        })

        var scene = [];

        //Create all the scroll scenes and store them in scene array
        for (var i = 0; i < section.length; i++) {
            scene.push(new ScrollMagic.Scene({
                triggerElement: ".c-sticky-sidebar__tabcontent--"+(i+1), 
                duration: $(".c-sticky-sidebar__tabcontent--"+(i+1)).height()
            })//Setting all tab contents as triggers
            .setClassToggle(".c-sticky-sidebar__link--"+(i+1), "c-sticky-sidebar__link--active")//Toggling active link class for corresponding tab
            .addIndicators()
            .addTo(controller));
        }


        //For each tabcontent we enter/trigger call sliding line so that it follows on scroll
        for (var i = 0; i < section.length; i++) {

            scene[i].on("enter", function (event) {
                var callback = $(this.triggerElement()).data('callback'),
                    param = $(this.triggerElement()).data('param');

                self.slidingLine();
                //Run callback for when element is scrolled into view (callback name set by callback data attribute)
                if (typeof callback != 'undefined') {
                    self[callback](param);
                }
            });

            //Just a small check to set the first link as active
            if(scene[0]) {
                scene[0].on("progress", function(event) {
                    if(event.scrollDirection == "REVERSE") {
                        scene[0].on("leave", function(event) {
                            if(event.state == "BEFORE") {
                                $(".c-sticky-sidebar__link--1").addClass("c-sticky-sidebar__link--active");
                            }
                        })
                    }
                });
            }

            //Another small check to see if last item is active
            if(scene[section.length-1]) {
                scene[section.length-1].on("progress", function(event) {
                    if(event.scrollDirection == "FORWARD") {
                        scene[section.length-1].on("leave", function(event) {
                            if(event.state == "AFTER") {
                                $(".c-sticky-sidebar__link--"+section.length).addClass("c-sticky-sidebar__link--active");
                            }
                        })
                    }
                })
            }
        }


            
    },
    openMobileContent (evt, name) {
        // Declare all variables
        var i, tabcontent, tablinks;

        $('.c-sticky-sidebar__tabcontent--active').removeClass('c-sticky-sidebar__tabcontent--animate-in').addClass('c-sticky-sidebar__tabcontent--animate-out');
    
        // Get all elements with class="tabcontent" and hide them
        $(".c-sticky-sidebar__tabcontent").removeClass("c-sticky-sidebar__tabcontent--active");

        setTimeout(function () {
            // Show the current tab, and add an "active" class to the link that opened the tab
            $("."+name).addClass("c-sticky-sidebar__tabcontent--active").siblings().removeClass('c-sticky-sidebar__tabcontent--active');
            $('.c-sticky-sidebar__tabcontent--active').removeClass('c-sticky-sidebar__tabcontent--animate-out').addClass('c-sticky-sidebar__tabcontent--animate-in');
        }, 500);

        return false;
        
    },
    scrollToContent(evt, name) {
        // Declare all variables
        var i, tabcontent, tablinks;
    
        // Get all elements with class="c-sticky-sidebar__link" and remove the class "active"
        $(".c-sticky-sidebar__link").removeClass("c-sticky-sidebar__link--active");
        
        
        //Scroll to section
        $('html, body').animate({
            scrollTop: $("."+name).offset().top - 150
        }, 2000);

        // Show the current tab, and add an "active" class to the link that opened the tab
        $(evt).addClass("c-sticky-sidebar__link--active");

        return false;
    },
    slidingLine() {
        var $el, topPos, newHeight,
        $mainNav = $(".c-sticky-sidebar__inner");
        
          // Create a new li and append it to ul
        $mainNav.append("<li class='c-sticky-sidebar__slidingLine'></li>");
        var $slidingLine = $(".c-sticky-sidebar__slidingLine");
  
        $slidingLine // Defining initial height and position
            .height($(".c-sticky-sidebar__link--active").outerHeight())
            .css("top", $(".c-sticky-sidebar__link--active").position().top)
            .data("origTop", $slidingLine.position().top)
            .data("origHeight", $slidingLine.height());       
        
        $(".c-sticky-sidebar__link").hover(function() { // Set new height and position
          $el = $(this);
          topPos = $el.position().top;
          newHeight = $el.outerHeight();
          $slidingLine.stop().animate({
              top: topPos,
              height: newHeight
          });
        }, function() { // Animate
          $slidingLine.stop().animate({
              top: $(".c-sticky-sidebar__link--active").position().top,
              height: $(".c-sticky-sidebar__link--active").outerHeight()
        });
      });
    },
    mapHighlight(target) {
        $('.js-map__country').removeClass('c-map__country--highlight');
        $('.c-map__country--' + target).addClass('c-map__country--highlight');
    }
}

var sectionLanding = {
    sidebar: null,
    init() {
        var self = this;

        if($(document).width() > 767) {
            this.initSectionLandingStickySidebar();
        }

        $(window).on('resize orientationchange', function () {
            if ($(document).width() < 767) {
                self.destroyStickySideBar();
            }
        });
    },
    initSectionLandingStickySidebar() {
        var offset;
        if ($(document).width() >= 1024) {
            offset = 114;
        }
        else {
            offset = 82;
        }

        $('.js-sidebar').stick_in_parent({
            offset_top: offset
        });
        
    },
    destroyStickySideBar() {
        $('.js-sidebar').trigger("sticky_kit:detach");
    }
    
}

var mapLocator = {
    init () {
        this.initStickyNav();
        this.initMapToolTips();
        this.initMapHighlighter();
        this.initFlagHover();
    },
    initStickyNav () {
        var stickymap = new StickySidebar('.js-sticky-map-content', {
            innerWrapperSelector: '.js-map-locator__inner',
            topSpacing: 163,
        });
    },
    initMapToolTips () {
        var $tooltip = $('.js-map__tooltip');

        $('[data-name]').hover(function () {
            if($(this).hasClass('c-map__country--highlight')) {
                var country = $(this).attr('id'),
                text = $(this).data('name');

                $(this).addClass('c-map__country--active');
                $tooltip.addClass('c-map__tooltip--active');
                $('.c-country', $tooltip).attr('class', 'c-country--multiline c-country c-country--' + country).html(text);
            }
            
        }, function () {
            $(this).removeClass('c-map__country--active');
            $tooltip.removeClass('c-map__tooltip--active');
        });

        $('.js-sticky-map-content').on('mousemove', function(e){
            $tooltip.css({
                left:  e.pageX,
                top:   e.pageY - 15
            });
        });
    },
    initMapHighlighter () {
        $(document).on('click', '.js-section-name', function () {
            var target = $(this).data('target');

            $('.js-map__country').removeClass('c-map__country--highlight');
            $('.c-map__country--' + target).addClass('c-map__country--highlight');
            
            return false;
        })
    },
    initFlagHover () {
        $(document).on({
            mouseenter: function () {
                var targetCountry = $(this).data('country'),
                    left = $(this).data('left'),
                    top = $(this).data('top'),
                    $tooltip = $('.js-map__hover-tooltip'),
                    countryText = $('#' + targetCountry).data('name');

                    if (top != '') {
                        $tooltip.addClass('c-map__tooltip--active');
                        $('.c-country', $tooltip).attr('class', 'c-country--multiline c-country c-country--' + targetCountry).html(countryText);

                        $tooltip.css({
                            left:  left,
                            top:   top
                        });
                    }
                    
            },
            mouseleave: function () {
                var $tooltip = $('.js-map__hover-tooltip');

                $tooltip.removeClass('c-map__tooltip--active');
            }
        }, '.c-map-section__flag');
    }
}

var dataTables = {
    init() {
        this.initTables();
    },
    initTables() {
        $('.js-data-table').each(function() {
            $(this).clone(true).appendTo($(this).parents('.js-data-table-wrapper')).addClass('c-data-table--clone');
        })
    }
}

$(document).ready(function () {
    global.init();
    
    if ($('.js-sidebar').length) {
        sectionLanding.init();
    }    
    if ($('.home').length) {
        home.init();
    }
    if ($('.c-sticky-sidebar').length) {
        content_navigation.init();
    }
    if ($('.js-map-locator').length) {
        mapLocator.init();
    }
    if ($('.js-data-table-wrapper').length) {
        dataTables.init();
    }
    
    if($('.js-hero-slider').length) {
        $('.js-hero-slider').on('init',global.setActiveSlideHero());
    }
    
    if($('.js-scroll-mobile-slider').length) {
        $('.js-scroll-mobile-slider').on('init',global.setActiveSliderTwoColumnLink());
    }
    
})


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/app.js
// module id = 39
// module chunks = 0